import Model from "../Model.js";

/**
 * CapegoIntegrationSettings which will define how Capego should be integrated.
 *
 * @param {string} officeCode - The office code
 */
export default class CapegoIntegrationSettings extends Model {
	constructor({ officeCode = "" } = {}) {
		super(...arguments);

		this._officeCode = officeCode;
	}

	getOfficeCode() {
		return this._officeCode;
	}

	setOfficeCode(officeCode) {
		this._officeCode = officeCode;
	}

	hasOfficeCode() {
		return this._officeCode && this._officeCode.length > 0;
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.officeCode = this._officeCode;
		return properties;
	}
}
